import localize from "../../../../common/localize";
import ReportSectionTitle from "../../../../components/common/ReportSectionTitle";
import ReportEvidenceItem from "./ReportEvidenceItem";

export default function ReportEvidenceData({
  eventId,
  evidences,
  reviews,
  original,
  isPanelReport,
}) {
  const evidencesList = (type) => {
    if (!evidences) {
      return null;
    }

    if (original) {
      return evidences?.filter((x) => x.EvidenceType !== 5 && x.EvidenceType !== 6);
    }

    if (!type) {
      return evidences?.filter((x) => x.Available === 1 && x.EvidenceType !== 5 && x.EvidenceType !== 6);
    }

    if (type === -1) {
      return evidences?.filter(
        (x) => x.Available === 1 && x.EvidenceType !== 1 && x.EvidenceType !== 5 && x.EvidenceType !== 6
      );
    }

    return evidences?.filter(
      (x) => x.Available === 1 && x.EvidenceType === type && x.EvidenceType !== 5 && x.EvidenceType !== 6
    );
  };

  const getFieldEvidences = (evidencesArray) => {
    if (evidencesArray?.length > 0) {
      return evidencesArray.map((evidence) => (
        <div key={evidence.Id} className="w-full">
          <ReportEvidenceItem
            key={`reportEvidenceItem_${evidence?.Id}`}
            eventId={eventId}
            evidence={evidence}
            reviews={reviews}
            original={original}
            panelReport={false}
          />
        </div>
      ));
    }
  };

  const getPanelReport = (evidencesArray) => {
    if (evidencesArray?.length > 0) {
      const evidencesGroup = [];
      const chunkSize = 3;
      for (let i = 0; i < evidencesArray.length; i += chunkSize) {
        const chunk = evidencesArray.slice(i, i + chunkSize);
        evidencesGroup.push(chunk);
      }

      return evidencesGroup.map((group) => (
        <div key={Math.random()}>
          <div key={Math.random()} className="page-break" />
          <div key={Math.random()} className="grid">
            {group?.map((evidence) => (
              <ReportEvidenceItem
                key={`reportEvidenceItem_${evidence?.Id}`}
                eventId={eventId}
                evidence={evidence}
                reviews={reviews}
                original={original}
                panelReport={isPanelReport}
              />
            ))}
          </div>
        </div>
      ));
    }
  };

  return (
    <div>
      <div key={Math.random()} className="page-break" />
      <ReportSectionTitle title={localize.evidences} />
      <div className="report_section_without_top_border">
        <label
          className="report_little_text"
          style={{
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {localize.evidences_description}
        </label>

        <div className={isPanelReport ? "evidence_section_background" : ""}>
          {isPanelReport
            ? getPanelReport(evidencesList(1))
            : getFieldEvidences(evidencesList())}
        </div>
        <div>{isPanelReport && getFieldEvidences(evidencesList(-1))}</div>
      </div>
    </div>
  );
}
